import { Link } from 'react-router-dom';

const AntiSlaveryPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section - Standardized */}
      <section className="bg-gradient-to-br from-slate-900 to-blue-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">Anti-Slavery Policy</h1>
            <p className="text-xl text-blue-100 leading-relaxed">
              Our commitment to preventing modern slavery and human trafficking across operations and supply chains
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8 pb-6 border-b border-slate-200">
            <p className="text-slate-600 text-sm">
              Enerlligence Analytics ("Company", "We", or "Our")
            </p>
            <p className="text-slate-500 text-sm mt-2">
              Effective Date: 1 January 2026 • Last Updated: 1 January 2026
            </p>
          </div>
          <div className="prose prose-lg max-w-none text-slate-700">
            
            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">1. Policy Statement</h2>
            <p className="mb-4 leading-relaxed">
              Enerlligence Analytics maintains a zero-tolerance approach to modern slavery, forced labour, human trafficking, servitude, and all forms of exploitative labour practices. The Company is committed to conducting business ethically, responsibly, and with integrity across all operations, supply chains, partnerships, and business relationships, consistent with internationally recognised human rights standards. We recognise our responsibility to prevent modern slavery risks within our organisation and throughout our value chain.
            </p>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">2. Scope of Application</h2>
            <p className="mb-4 leading-relaxed">This Policy applies to:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Directors and employees</li>
              <li>Contractors and consultants</li>
              <li>Suppliers and service providers</li>
              <li>Business partners and affiliates</li>
              <li>Third-party representatives acting on behalf of the Company</li>
            </ul>
            <p className="mb-4 leading-relaxed">Compliance with this Policy forms part of the Company's broader governance and ESG framework.</p>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">3. Definition of Modern Slavery</h2>
            <p className="mb-4 leading-relaxed">Modern slavery includes, but is not limited to:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Forced or compulsory labour</li>
              <li>Human trafficking</li>
              <li>Debt bondage</li>
              <li>Child labour inconsistent with international standards</li>
              <li>Servitude or exploitative employment practices</li>
              <li>Withholding of identity or travel documents</li>
              <li>Coercion, intimidation, or abuse of vulnerability</li>
            </ul>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">4. Corporate Commitment</h2>
            <p className="mb-4 leading-relaxed">The Company commits to:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Upholding internationally recognised human rights principles</li>
              <li>Ensuring employment relationships are voluntary and lawful</li>
              <li>Providing fair wages and lawful working conditions</li>
              <li>Prohibiting child labour and forced labour practices</li>
              <li>Promoting dignity, equality, and safe working environments</li>
              <li>Integrating anti-slavery considerations into corporate governance and risk management processes</li>
            </ul>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">5. Supply Chain Responsibility</h2>
            <p className="mb-4 leading-relaxed">The Company expects all suppliers and partners to:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Operate in compliance with applicable labour laws</li>
              <li>Maintain ethical employment practices</li>
              <li>Prohibit forced or trafficked labour</li>
              <li>Ensure workers are employed voluntarily</li>
              <li>Maintain transparent recruitment practices</li>
            </ul>
            <p className="mb-4 leading-relaxed">Suppliers may be required to confirm compliance through contractual commitments or due diligence assessments.</p>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">6. Risk Assessment and Due Diligence</h2>
            <p className="mb-4 leading-relaxed">The Company undertakes proportionate measures to identify and mitigate modern slavery risks, including:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Vendor and partner due diligence procedures</li>
              <li>Contractual ethical compliance requirements</li>
              <li>Periodic supplier review processes</li>
              <li>ESG and governance screening where appropriate</li>
            </ul>
            <p className="mb-4 leading-relaxed">Higher-risk jurisdictions or engagements may be subject to enhanced review.</p>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">7. Reporting and Whistleblowing</h2>
            <p className="mb-4 leading-relaxed">Employees and stakeholders are encouraged to report concerns relating to suspected modern slavery or unethical labour practices. Reports may be made through:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Line management channels</li>
              <li>Human Resources</li>
              <li>Compliance or Ethics reporting mechanisms</li>
            </ul>
            <p className="mb-4 leading-relaxed">All concerns will be treated confidentially and investigated appropriately. Retaliation against individuals raising concerns in good faith is strictly prohibited.</p>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">8. Training and Awareness</h2>
            <p className="mb-4 leading-relaxed">The Company promotes awareness of modern slavery risks through:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Employee induction programmes</li>
              <li>Governance and compliance briefings</li>
              <li>Supplier engagement expectations</li>
              <li>Periodic policy communication</li>
            </ul>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">9. Governance and Oversight</h2>
            <p className="mb-4 leading-relaxed">
              Oversight of this Policy rests with Executive Management and the Board, which maintains responsibility for ensuring effective implementation, ongoing monitoring, and continuous improvement of ethical business practices.
            </p>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">10. Breach of Policy</h2>
            <p className="mb-4 leading-relaxed">
              Failure to comply with this Policy may result in disciplinary action, termination of employment or engagement, or cessation of business relationships with third parties.
            </p>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">11. Continuous Improvement</h2>
            <p className="mb-4 leading-relaxed">
              The Company commits to periodically reviewing and strengthening its approach to preventing modern slavery in line with evolving international standards and regulatory expectations.
            </p>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">12. Approval</h2>
            <p className="mb-4 leading-relaxed">
              This Policy is approved by the Board of Directors of Enerlligence Analytics and forms part of the Company's corporate governance and sustainability framework.
            </p>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">13. Contact Information</h2>
            <p className="mb-4 leading-relaxed">For enquiries regarding this Policy:</p>
            <div className="bg-slate-50 p-6 rounded-lg border border-slate-200 mb-6">
              <p className="font-semibold text-[#1F3C88] mb-2">Legal & Compliance Department</p>
              <p className="text-slate-600">Enerlligence Analytics</p>
              <p className="text-slate-600">Email: <a href="mailto:compliance@enerlligence.com" className="text-[#007BFF] hover:underline">compliance@enerlligence.com</a></p>
              <p className="text-slate-600">Website: <a href="https://www.enerlligence.com" className="text-[#007BFF] hover:underline">www.enerlligence.com</a></p>
            </div>

            {/* Related Links */}
            <div className="mt-12 pt-8 border-t border-slate-200">
              <h3 className="text-lg font-semibold text-[#1F3C88] mb-4">Related Policies</h3>
              <div className="flex flex-wrap gap-4">
                <Link to="/disclaimer" className="text-[#007BFF] hover:underline">Disclaimer</Link>
                <Link to="/terms-of-service" className="text-[#007BFF] hover:underline">Terms of Service</Link>
                <Link to="/privacy-policy" className="text-[#007BFF] hover:underline">Privacy Policy</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AntiSlaveryPolicy;
